import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { RbacService } from './services/rbac.service';
import { fromEvent } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AuthService } from './services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  constructor(
    private auth: AuthService,
    private rbac: RbacService,
    private _title: Title
  ) { }


  ngOnInit() {
    this._title.setTitle(environment.softwareName)

    if (this.auth.getJwtToken()) {
      this.rbac.ensureLoaded().subscribe();
    }

    fromEvent(window, 'focus').subscribe(() => this.rbac.ensureLoaded().subscribe());

    fromEvent(document, 'visibilitychange').pipe(
      filter(() => document.visibilityState === 'visible')
    ).subscribe(() => this.rbac.ensureLoaded().subscribe());
  }

}
